var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._g(_vm._b({staticClass:"block tab transition-colors duration-100 border-b-2 border-transparent tab focus:outline-none text-gray-900",class:( _obj = {
    'cursor-not-allowed opacity-50': _vm.disabled,
    'hover:border-orange-mia': !_vm.disabled
  }, _obj[_vm.sizeClasses] = true, _obj ),attrs:{"active-class":"border-orange-mia"}},'router-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }